type DataType = { [key: string]: any };

export default <S extends DataType>(init: S): Partial<S> => {
  const result = { ...init };

  Object.keys(result).forEach((field) => {
    const value = result[field];

    // check for null
    if (value === null) {
      return delete result[field];
    }

    // check for numbers > 0
    if (value > 0) {
      return;
    }

    // check of no value at all
    if (!value) {
      return delete result[field];
    }

    // check if object value has length
    if (!Array.isArray(value) && !Object.values(value).length) {
      return delete result[field];
    }

    // check if array no length
    if (Array.isArray(value) && !value.length) {
      return delete result[field];
    }
  });

  return result;
};
